// extracted by mini-css-extract-plugin
export default {"root":"VideoLocalPlayer_root__Pl+ur","video":"VideoLocalPlayer_video__IiGvj"};